export default "__VITE_ASSET__DNl6W8fI__"